module.exports = __webpack_public_path__ + "static/media/process-performance.abe13aef.svg";